export default __webpack_public_path__ + "b56d15521a0481921bd141de39957a2d.png";